import React from "react";
import CRUDFormDialog from "./CRUDFormDialog";
import { ResourceName } from "../descriptors";
import { useRevalidator } from "react-router-dom";
import { Button, IconButton } from "@mui/material";
import { FormattedMessage } from "react-intl";
import { FormActionButton } from "./CRUDForm";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faPlus } from "@fortawesome/free-solid-svg-icons";

/// button to open a create or update resource form in a dialog
const ResourceFormButton: React.FC<{
    resourceName: ResourceName;
    action: "create" | "update";
    id?: number; // id to update when action is update
    extraButtons?: FormActionButton[];
    extraRequestData?: Record<string, any>; /// extra data to be sent with the request
    size?: "small" | "medium" | "large";
    buttonType?: "text" | "icon" | "section-icon";
}> = ({ resourceName, action, extraButtons, extraRequestData, id, buttonType = "text", size = "small" }) => {
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const revalidator = useRevalidator();

    return (
        <>
            {buttonType !== "text" ? (
                <IconButton
                    onClick={() => {
                        setDialogOpen(true);
                    }}
                    sx={
                        buttonType === "section-icon"
                            ? {
                                  bgcolor: "primary.main",
                                  color: "primary.contrastText",
                                  "&:hover": {
                                      bgcolor: "primary.dark",
                                  },
                              }
                            : {
                                  color: "primary.main",
                              }
                    }
                >
                    <FontAwesomeIcon icon={action == "create" ? faPlus : faPencil} />
                </IconButton>
            ) : (
                <Button
                    variant="contained"
                    size={size}
                    onClick={() => {
                        setDialogOpen(true);
                    }}
                >
                    <FormattedMessage id={action} />
                </Button>
            )}
            <CRUDFormDialog
                open={dialogOpen}
                titleId={`${resourceName}.${action}`}
                hide={() => setDialogOpen(false)}
                action={action}
                id={id}
                resourceName={resourceName}
                onSuccess={() => {
                    setDialogOpen(false);
                    revalidator.revalidate();
                }}
                extraButtons={extraButtons}
                extraRequestData={extraRequestData}
            />
        </>
    );
};

export default ResourceFormButton;
